export class ContentWrapperHelper {
  static get currentBreakpoint() {
    if (window.matchMedia('(min-width: 1200px)').matches) {
      return 12;
    }
    return 8;
  }
}
